import { render, staticRenderFns } from "./FiltersBaseDesign.vue?vue&type=template&id=16c1b3d2&"
import script from "./FiltersBaseDesign.vue?vue&type=script&lang=ts&"
export * from "./FiltersBaseDesign.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersBaseDesign.vue?vue&type=style&index=0&id=16c1b3d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports